import React from 'react';
import TextField from '@mui/material/TextField';
import { connect } from 'react-redux';
import setCityAction from '../../redux/actions/createReferenceActions/actionCity';
import { withTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)({
  '& .MuiOutlinedInput-notchedOutline': {
    '&:hover': {
      borderColor: "rgb(0,191,255)",
    },
    '&.Mui-focused': {
      borderColor: "rgb(47, 79, 79)",
    },
  },
  '& .Mui-focused': {
    color: 'white',
  },
  width: 300,
  marginTop: 10,
  fontSize: 30,
  backgroundColor: 'rgba(19, 174, 236, 0.54)',
  fontWeight: 'bold'
});

class CityForm extends React.Component {

  constructor(props) {
    super(props);

    if(this.props.selectedReferenceData && window.location.href.indexOf('/editRef') > -1) {
      this.state = { city: this.props.selectedReferenceData.city };
      this.props.setCityFunction(this.state.city);
    } else {
      this.state = { city: '' };
      this.props.setCityFunction('defaultCity');
    }
  }

  shouldComponentUpdate(nextProps, nextState) {

    if (this.props.city !== nextProps.city) {
      this.setState({ city: nextProps.city}, () => {
        this.props.setCityFunction(this.state.city);
      })
      return false;
    } else {
      return true;
    }
  }

  render() {
    const { t } = this.props;

    return (
      <div>
        <div>
          <StyledTextField key={this.props.searchVal} disabled={true} value={this.state.city} inputProps={{ maxLength: 30, style: {fontWeight: 'bold'} }} label={t('create_ref.city') + "*"} variant="outlined" error={this.props.cityError} 
             style={{ width: 300, marginTop: 10, fontSize: 30, backgroundColor: 'rgba(19, 174, 236, 0.54)' }}/>
        </div>
      </div>
    );
  }
}

function mapDispathToProps(dispatch) {
  return {
    setCityFunction: city => {
      dispatch(setCityAction(city))
    }
  }

}
function mapStateToProps(state) {
  return {
    id: state.createRefState.id,
    cityError: state.createRefState.cityError,
    selectedReferenceData: state.showRefState.selectedReferenceData
  }
}

export default connect(mapStateToProps, mapDispathToProps)(withTranslation()(CityForm));